module.exports = __webpack_public_path__ + "img/tm.b792aa42.svg";